const createQueryString = (key: string, value?: string) => {
  return `${key}=${value}`;
};

const createCauseQueryString = (causeId?: string) => {
  return createQueryString('cause_id', causeId);
};
export { createCauseQueryString };
